import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, AppBar, Toolbar, Button } from '@mui/material';
import TranslatedText from '../components/TranslatedText';
import LanguageSelector from '../components/LanguageSelector';
import { useLanguage } from '../context/LanguageContext';

const TOSPage = () => {
  const { language } = useLanguage();
  
  return (
    <Box>
      {/* Header */}
      <AppBar position="fixed" sx={{ bgcolor: 'rgb(25, 118, 210)' }}>
        <Box sx={{ flexGrow: 1 }}>
          <Toolbar>
            <Typography variant="h6" component={Link} to="/" sx={{ flexGrow: 1, color: 'white', textDecoration: 'none' }}>
              Unpen
            </Typography>
            <LanguageSelector />
            <Button color="inherit" component={Link} to="/login">
              <TranslatedText textId="signin" />
            </Button>
          </Toolbar>
        </Box>
      </AppBar>
      
      {/* Main Content */}
      <Container maxWidth="lg" sx={{ pt: 10, pb: 6 }}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          <TranslatedText textId="TOS" />
        </Typography>
        
        <Box sx={{ height: 'calc(100vh - 200px)', width: '100%', mt: 4 }}>
          <iframe 
            src={`https://unpen.eu/TOS_pdf/${language}`} 
            width="100%" 
            height="100%" 
            title="Terms of Service" 
            style={{ border: 'none' }}
          />
        </Box>
      </Container>
      
      {/* Footer */}
      <Box component="footer" sx={{ bgcolor: 'rgb(25, 118, 210)', py: 3, textAlign: 'center' }}>
        <Link to={`/${language === 'en' ? '' : language}`} style={{ color: 'white', margin: '0 25px' }}>
          <TranslatedText textId="features" />
        </Link>
        <Link to={`/${language === 'en' ? '' : language}/legal`} style={{ color: 'white', margin: '0 25px' }}>
          <TranslatedText textId="legalMention" />
        </Link>
      </Box>
    </Box>
  );
};

export default TOSPage; 